import React from 'react';
import SavedPaymentMethodCard from '@/components/payment/SavedPaymentMethodCard';
import { getNmiCardOnFile } from '@/utils/nmiCardDisplay';

/**
 * Read-only card-on-file row for NMI bookings (single vault per customer).
 */
export default function NmiCardOnFileDisplay({
  flightData,
  className = '',
  fallbackText = "We'll charge the card on file for this trip — the same one used for your installment plan.",
}) {
  const card = getNmiCardOnFile(flightData);

  if (!card) {
    return (
      <p className={`text-white/60 text-sm font-normal leading-relaxed ${className}`}>
        {fallbackText}
      </p>
    );
  }

  return (
    <SavedPaymentMethodCard
      brand={card.brand}
      last4={card.last4}
      expMonth={card.expMonth}
      expYear={card.expYear}
      readOnly
      selected
      badge="On file"
      className={className}
    />
  );
}
